import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { requestLogout } from '@src/actions/common';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { ExitOutlinedIcon } from '../SvgIcons';

interface LogoutActionProps {
  displayIconText?: boolean;
}

const LogoutAction: React.FC<LogoutActionProps> = ({ displayIconText }) => {
  const dispatch = useDispatch();
  const { spacing, textIcon, styleIcon } = useStyles();
  return (
    <ButtonBase onClick={() => dispatch(requestLogout())} className={spacing}>
      <Box className={styleIcon}>{ExitOutlinedIcon}</Box>
      <Box className={textIcon}>
        {displayIconText && <FormattedMessage id="HeaderMenu.Logout" />}
      </Box>
    </ButtonBase>
  );
};

export default LogoutAction;

const useStyles = makeStyles(theme => ({
  spacing: { display: 'flex', gap: '8px', alignItems: 'center' },
  textIcon: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    fontWeight: 500,
  },
  styleIcon: {
    color:
      theme.palette.type === 'dark'
        ? theme.palette.text.secondary
        : 'rgb(63, 63, 70)',
    display: 'flex',
    justifyContent: 'center',
    width: 24,
  },
}));
